export default "__VITE_ASSET__yrb4FoU4__"